import {
  getDetailsTabRoutes,
  getSelectableResult
} from "../../../utility/route";
import { childOfOrEqual } from "../../../router/functions";

export const bookingVenueListLDTRoutes = getDetailsTabRoutes(
  "venues",
  "venue_id"
);

export const bookingTemplateListLDTRoutes = getDetailsTabRoutes(
  "templates",
  "booking_template_id"
);

export const bookingArtistListLDTRoutes = getDetailsTabRoutes(
  "artists",
  "artist_id"
);
export const bookingPromoterListLDTRoutes = getDetailsTabRoutes(
  "promoters",
  "promoter_id"
);

export const getBookingArtistDetailsSelectable = getSelectableResult(
  bookingArtistListLDTRoutes
);

export const getBookingPromoterDetailsSelectable = getSelectableResult(
  bookingPromoterListLDTRoutes
);

export const getBookingVenueDetailsSelectable = getSelectableResult(
  bookingVenueListLDTRoutes
);

export const getBookingTemplateDetailsSelectable = getSelectableResult(
  bookingTemplateListLDTRoutes
);

export const moduleRoutes = [
  bookingVenueListLDTRoutes,
  bookingArtistListLDTRoutes,
  bookingPromoterListLDTRoutes,
  bookingTemplateListLDTRoutes
];

const detailsRoutes = moduleRoutes.map(m => m.names.details);

export const childOfOrEqualDetails = route => {
  return detailsRoutes.map(r => childOfOrEqual(r)).some(f => f(route.name));
};
